// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

import { StyleSheet, TextInput, View } from 'react-native';
import { Text } from '@/components/Themed';
import appColors from '@/theme/colors';
import SectionHeading from '../shared/SectionHeading';
import { useAutoSave } from '../../hooks/useAutoSave';
import { useRef } from 'react';

type Props = {
  tourName: string;
  onNameChange: (value: string) => void;
  onSave: (reason: string) => void;
  saving: boolean;
};

export default function TourNameEditor({ tourName, onNameChange, onSave, saving }: Props) {
  const lastSavedRef = useRef(tourName);

  useAutoSave(tourName, lastSavedRef.current, () => {
    lastSavedRef.current = tourName.trim();
    onSave('tour.name.autosave');
  });

  return (
    <View style={styles.container}>
      <SectionHeading title="Tour Name" />
      <TextInput
        style={styles.input}
        value={tourName}
        onChangeText={onNameChange}
        placeholder="Enter tour name..."
        placeholderTextColor={appColors.text.muted}
        editable={!saving}
      />
      {saving && <Text style={styles.savingText}>Saving...</Text>}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    gap: 8,
  },
  input: {
    borderWidth: 1,
    borderColor: appColors.border.default,
    borderRadius: 12,
    backgroundColor: appColors.surface.input,
    paddingHorizontal: 14,
    paddingVertical: 12,
    fontSize: 16,
    fontWeight: '600',
    color: appColors.text.primary,
  },
  savingText: {
    fontSize: 12,
    color: appColors.text.muted,
    fontStyle: 'italic',
  },
});
